import type { ISubmittableResult } from '@polkadot/types/types';

import * as R from 'ramda';

export function isSubmittableResultEventsInclude(result: ISubmittableResult, method: string) {
  return R.find(i => i.event.method === method, result.events) !== undefined
}

export function getEventData<T=unknown[]>(result: ISubmittableResult, method: string): T {
  const matched = R.find(i => i.event.method === method, result.events)
  if (matched) {
    return matched.event.data.map(i => i.toJSON()) as T
  }
  return [] as T
}
